<div class="report-popup-container">
  <!-- Header -->
  <div class="popup-header">
    <h2>Upload Final Temperature Log</h2>
    <mat-icon class="close-btn" (click)="closeModal()">close</mat-icon>
  </div>

  <div class="popup-body">
 
    <button class="upload-btn" (click)="uploadFile()" [disabled]="isUploading">
      <mat-icon>upload</mat-icon>
      {{ isUploading ? 'Uploading...' : 'Upload Excel' }}
    </button>

   
    <div *ngIf="selectedFile" class="file-name" [class.file-valid]="fileValidationPassed">
      {{ selectedFile.name }}
    </div>

    <p *ngIf="isValidatingFile" style="color: #0369a1; font-size: 13px; margin: 0;">
      Validating file format and voyage log data...
    </p>

    <p *ngIf="!selectedFile" style="color: #888; font-size: 13px; margin: 0;">
      Upload temperature log (.xls, .xlsx, .xlsm, .csv, max 10 MB) to mark voyage as completed
    </p>

    <div *ngIf="validationErrors.length" class="validation-errors">
      <p><strong>Validation issues</strong></p>
      <ul>
        <li *ngFor="let error of validationErrors">{{ error }}</li>
      </ul>
    </div>
  </div>


  <div class="button-row">
    <button class="btn submit-btn" (click)="submitFile()" [disabled]="!canSubmit || isUploading">
      {{ isUploading ? 'Processing...' : 'Submit' }}
    </button>
    <button class="btn cancel-btn" (click)="closeModal()" [disabled]="isUploading">
      Cancel
    </button>
  </div>
</div>